export const getDashboardTitle = (currentViewRole: string | undefined): string => {
  switch (currentViewRole) {
    case 'medical':
      return 'Medical Dashboard';
    case 'scout':
      return 'Scout Dashboard';
    case 'coach':
      return 'Coach Dashboard';
    default:
      return 'Manager Dashboard';
  }
};

export const getDashboardSubtitle = (currentViewRole: string | undefined): string => {
  switch (currentViewRole) {
    case 'medical':
      return 'Medical overview and health monitoring';
    case 'scout':
      return 'Player scouting and performance analysis';
    case 'coach':
      return 'Training, player development and match preparation';
    default:
      return 'Comprehensive team overview for strategic decisions';
  }
};
